<mat-card>
    <div class="d-flex justify-content-between w-100" >
        <div class="container1">
            <div class="header">

                <h6>{{fund.enterpriseType ? (fund.enterpriseType | normalizeString | translate) : ''}}</h6>
            </div>
            <div class="details w-100">
               <div class="detail">
                    <span class="key">{{'livelihoodActivity' | translate}}:</span>
                    <span class="value">
                        {{fund.livelihoodActivity ? ((fund.livelihoodActivity | normalizeString | translate)) : 'NA'}}
                    </span>
                </div>
                <div class="detail">
                    <span class="key">{{'source' | translate}}:</span>
                    <span class="value">
                        {{fund.loanSource ? (fund.loanSource  | translate) : 'NA'}}
                    </span>
                </div>
                <div class="detail">
                    <span class="key">{{'type' | translate}}:</span>
                    <span class="value">{{fund.loanType ? (fund.loanType  | translate) : 'NA'}}</span>
                </div>
                <div class="detail">
                    <span class="key">{{'enterpriseType' | translate}}:</span>
                    <span class="value">{{fund.enterpriseType ? (fund.enterpriseType | normalizeString | translate) :
                        'NA'}}</span>
                </div>
                <div class="detail">
                    <span class="key">{{'amount' | translate}}:</span>
                    <span class="value">₹{{fund.amount | indianFormat}}</span>
                </div>
                  <div class="detail">
                    <span class="key">{{'ownContribution' | translate}}(₹) :</span>
                    <span class="value">₹{{fund.ownContribution ? (fund.ownContribution | indianFormat) : 'NA'}}</span>
                </div>
                <div class="action-detail">
                  <button type="button" (click)="edit()">
                        @if (!readOnly) {
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/edit.svg" alt="">
                            <span class="menu-labels">{{'edit' | translate}}</span>
                        } @else {
                            <img class="menu-icons" src="../../../../assets/images/eyeIcon.svg" alt="">
                            <span class="menu-labels">{{'view' | translate}}</span>
                        }
                    </button>
                    @if (!readOnly) {
                        <button type="button" (click)="delete()" [ngClass]="{'disabled': readOnly}">
                            <img class="menu-icons" src="https://cdn.lokos.in/aajeevika/assets/img/delete.svg" alt="" >
                            <span class="menu-labels">{{'delete' | translate}}</span>
                        </button>
                    }
                </div>
            </div>
        </div>

    </div>
</mat-card>
